import { render, staticRenderFns } from "./Otp.vue?vue&type=template&id=6fbd6e20&"
import script from "./Otp.vue?vue&type=script&lang=js&"
export * from "./Otp.vue?vue&type=script&lang=js&"
import style0 from "./Otp.vue?vue&type=style&index=0&id=6fbd6e20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports